(function () {
    'use strict';
  
    function initConsultationForms() {
      var stickyCta = document.getElementById('primo-sticky-cta');
      var bookSection =
        document.querySelector('[data-primo-consultation-hero][id]') ||
        document.querySelector('[data-primo-consultation][id]');
  
      document.querySelectorAll('a[href="#book-consultation"]').forEach(function (anchor) {
        if (bookSection && bookSection.id && bookSection.id !== 'book-consultation') {
          anchor.setAttribute('href', '#' + bookSection.id);
        }
      });
  
      if (stickyCta && bookSection && 'IntersectionObserver' in window && !bookSection.dataset.stickyBound) {
        bookSection.dataset.stickyBound = 'true';
        var stickyObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              stickyCta.classList.toggle('is-hidden', entry.isIntersecting);
            });
          },
          { root: null, threshold: 0.15 }
        );
        stickyObserver.observe(bookSection);
      }
  
      document.querySelectorAll('[data-primo-consult-form]:not([data-pcf-bound])').forEach(bindTwoStepForm);
      document.querySelectorAll('[data-primo-consult-form-single]:not([data-pcf-bound])').forEach(bindSingleForm);
    }

    function prefillFromQuizParams(form) {
      var params = new URLSearchParams(window.location.search);
      var fullName = (params.get('name') || '').trim();
      var email = (params.get('email') || '').trim();
      var phone = (params.get('phone') || '').trim();

      if (fullName) {
        var parts = fullName.split(/\s+/);
        var firstName = parts.shift() || '';
        var lastName = parts.join(' ');
        var firstField = form.querySelector('[data-field="first_name"]');
        var lastField = form.querySelector('[data-field="last_name"]');

        if (firstField && !firstField.value.trim()) firstField.value = firstName;
        if (lastField && !lastField.value.trim()) lastField.value = lastName;
      }

      var emailField = form.querySelector('[data-field="email"]');
      var phoneField = form.querySelector('[data-field="phone"]');

      if (emailField && !emailField.value.trim() && email) emailField.value = email;
      if (phoneField && !phoneField.value.trim() && phone) phoneField.value = phone;
    }
  
    function todayIso() {
      var now = new Date();
      return (
        now.getFullYear() +
        '-' +
        String(now.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(now.getDate()).padStart(2, '0')
      );
    }
  
    function handleFormSuccess(form, options) {
      var redirectUrl = (form.getAttribute('data-redirect-url') || '').trim();
      if (redirectUrl) {
        window.location.assign(redirectUrl);
        return;
      }
  
      if (options.progress) options.progress.hidden = true;
      if (options.formBody) options.formBody.hidden = true;
      if (options.panel1) options.panel1.hidden = true;
      if (options.panel2) options.panel2.hidden = true;
      if (options.successPanel) options.successPanel.hidden = false;
    }
  
    function bindTwoStepForm(form) {
      form.dataset.pcfBound = 'true';
      prefillFromQuizParams(form);
      var currentStep = 1;
      var submitText = form.getAttribute('data-submit-text') || 'Request Consultation';
      var webhookUrl = (form.getAttribute('data-webhook-url') || '').trim();
      var panel1 = form.querySelector('[data-step-panel="1"]');
      var panel2 = form.querySelector('[data-step-panel="2"]');
      var successPanel = form.querySelector('[data-success-panel]');
      var progressFill = form.querySelector('[data-progress-fill]');
      var progressLabel = form.querySelector('[data-progress-label]');
      var formError = form.querySelector('[data-form-error]');
      var submitBtn = form.querySelector('[data-submit-btn]');
      var continueBtn = form.querySelector('[data-step-next]');
      var backBtn = form.querySelector('[data-step-back]');
      var dateInput = form.querySelector('[data-field="preferred_date"]');
  
      if (dateInput) dateInput.setAttribute('min', todayIso());
  
      function getField(name) {
        return form.querySelector('[data-field="' + name + '"]');
      }
  
      function getFieldWrap(name) {
        var field = getField(name);
        return field ? field.closest('.primo-consult-form__field') : null;
      }
  
      function setFieldError(name, message) {
        var wrap = getFieldWrap(name);
        var errorEl = form.querySelector('[data-error-for="' + name + '"]');
        var field = getField(name);
        if (wrap) wrap.classList.toggle('is-invalid', Boolean(message));
        if (errorEl) {
          errorEl.textContent = message || '';
          errorEl.hidden = !message;
        }
        if (field) field.setAttribute('aria-invalid', message ? 'true' : 'false');
      }
  
      function clearErrors() {
        form.querySelectorAll('[data-error-for]').forEach(function (el) {
          el.hidden = true;
          el.textContent = '';
        });
        form.querySelectorAll('.primo-consult-form__field.is-invalid').forEach(function (el) {
          el.classList.remove('is-invalid');
        });
        form.querySelectorAll('[data-field]').forEach(function (field) {
          field.removeAttribute('aria-invalid');
        });
        if (formError) formError.hidden = true;
      }
  
      function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }
  
      function isValidPhone(value) {
        return value.replace(/\D/g, '').length >= 7;
      }
  
      function isSunday(dateValue) {
        if (!dateValue) return false;
        var parts = dateValue.split('-');
        var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        return date.getDay() === 0;
      }
  
      function isPastDate(dateValue) {
        return dateValue && dateValue < todayIso();
      }
  
      function validateStep1() {
        clearErrors();
        var valid = true;
        if (!(getField('first_name').value || '').trim()) {
          setFieldError('first_name', 'Please enter your first name.');
          valid = false;
        }
        if (!(getField('last_name').value || '').trim()) {
          setFieldError('last_name', 'Please enter your last name.');
          valid = false;
        }
        var email = (getField('email').value || '').trim();
        if (!email) {
          setFieldError('email', 'Please enter your email address.');
          valid = false;
        } else if (!isValidEmail(email)) {
          setFieldError('email', 'Please enter a valid email address.');
          valid = false;
        }
        var phone = (getField('phone').value || '').trim();
        if (!phone) {
          setFieldError('phone', 'Please enter your phone number.');
          valid = false;
        } else if (!isValidPhone(phone)) {
          setFieldError('phone', 'Please enter a valid phone number.');
          valid = false;
        }
        return valid;
      }
  
      function validateStep2() {
        clearErrors();
        var valid = true;
        if (!getField('consultation_type').value) {
          setFieldError('consultation_type', 'Please select a consultation type.');
          valid = false;
        }
        var preferredDate = getField('preferred_date').value;
        if (!preferredDate) {
          setFieldError('preferred_date', 'Please choose a preferred date.');
          valid = false;
        } else if (isPastDate(preferredDate)) {
          setFieldError('preferred_date', 'Please choose a future date.');
          valid = false;
        } else if (isSunday(preferredDate)) {
          setFieldError('preferred_date', 'Sundays are unavailable. Please choose another day.');
          valid = false;
        }
        if (!getField('preferred_time').value) {
          setFieldError('preferred_time', 'Please select a preferred time.');
          valid = false;
        }
        return valid;
      }
  
      function updateProgress(step) {
        if (progressFill) progressFill.style.width = step === 1 ? '50%' : '100%';
        if (progressLabel) progressLabel.textContent = 'Step ' + step + ' of 2';
      }
  
      function goToStep(step) {
        currentStep = step;
        if (panel1) panel1.hidden = step !== 1;
        if (panel2) panel2.hidden = step !== 2;
        updateProgress(step);
      }
  
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          if (!validateStep1()) {
            var firstInvalid = form.querySelector('.primo-consult-form__field.is-invalid [data-field]');
            if (firstInvalid) firstInvalid.focus();
            return;
          }
          goToStep(2);
          var firstStep2Field = panel2 && panel2.querySelector('[data-field]');
          if (firstStep2Field) firstStep2Field.focus();
        });
      }
  
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          goToStep(1);
          if (formError) formError.hidden = true;
        });
      }
  
      if (dateInput) {
        dateInput.addEventListener('change', function () {
          if (isSunday(dateInput.value)) {
            setFieldError('preferred_date', 'Sundays are unavailable. Please choose another day.');
          } else if (isPastDate(dateInput.value)) {
            setFieldError('preferred_date', 'Please choose a future date.');
          } else {
            setFieldError('preferred_date', '');
          }
        });
      }
  
      form.querySelectorAll('[data-field]').forEach(function (field) {
        ['input', 'change'].forEach(function (evt) {
          field.addEventListener(evt, function () {
            var name = field.getAttribute('data-field');
            if (name) setFieldError(name, '');
          });
        });
      });
  
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (currentStep !== 2) return;
        if (!validateStep2()) {
          var firstInvalid = form.querySelector('.primo-consult-form__field.is-invalid [data-field]');
          if (firstInvalid) firstInvalid.focus();
          return;
        }
        if (!webhookUrl) {
          if (formError) formError.hidden = false;
          return;
        }
  
        var helpField = getField('help_with');
        var budgetField = getField('budget');
        var messageField = getField('message');
  
        var payload = {
          first_name: getField('first_name').value.trim(),
          last_name: getField('last_name').value.trim(),
          email: getField('email').value.trim(),
          phone: getField('phone').value.trim(),
          consultation_type: getField('consultation_type').value,
          preferred_date: getField('preferred_date').value,
          preferred_time: getField('preferred_time').value,
          help_with: helpField ? helpField.value : '',
          budget: budgetField ? budgetField.value : '',
          message: messageField ? messageField.value.trim() : ''
        };
  
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting...';
        }
        if (formError) formError.hidden = true;
  
        fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            handleFormSuccess(form, {
              panel1: panel1,
              panel2: panel2,
              progress: form.querySelector('.primo-consult-form__progress'),
              successPanel: successPanel
            });
          })
          .catch(function () {
            if (formError) formError.hidden = false;
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitText;
            }
          });
      });
    }
  
    function bindSingleForm(form) {
      form.dataset.pcfBound = 'true';
      prefillFromQuizParams(form);
      var submitText = form.getAttribute('data-submit-text') || 'Request Consultation';
      var webhookUrl = (form.getAttribute('data-webhook-url') || '').trim();
      var formBody = form.querySelector('[data-form-body]');
      var successPanel = form.querySelector('[data-success-panel]');
      var formError = form.querySelector('[data-form-error]');
      var submitBtn = form.querySelector('[data-submit-btn]');
      var dateInput = form.querySelector('[data-field="preferred_date"]');
  
      if (dateInput) dateInput.setAttribute('min', todayIso());
  
      function getField(name) {
        return form.querySelector('[data-field="' + name + '"]');
      }
  
      function getFieldWrap(name) {
        var field = getField(name);
        return field ? field.closest('.primo-consult-form__field') : null;
      }
  
      function setFieldError(name, message) {
        var wrap = getFieldWrap(name);
        var errorEl = form.querySelector('[data-error-for="' + name + '"]');
        var field = getField(name);
        if (wrap) wrap.classList.toggle('is-invalid', Boolean(message));
        if (errorEl) {
          errorEl.textContent = message || '';
          errorEl.hidden = !message;
        }
        if (field) field.setAttribute('aria-invalid', message ? 'true' : 'false');
      }
  
      function clearErrors() {
        form.querySelectorAll('[data-error-for]').forEach(function (el) {
          el.hidden = true;
          el.textContent = '';
        });
        form.querySelectorAll('.primo-consult-form__field.is-invalid').forEach(function (el) {
          el.classList.remove('is-invalid');
        });
        if (formError) formError.hidden = true;
      }
  
      function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }
  
      function isValidPhone(value) {
        return value.replace(/\D/g, '').length >= 7;
      }
  
      function isSunday(dateValue) {
        if (!dateValue) return false;
        var parts = dateValue.split('-');
        var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        return date.getDay() === 0;
      }
  
      function isPastDate(dateValue) {
        return dateValue && dateValue < todayIso();
      }
  
      function validateForm() {
        clearErrors();
        var valid = true;
        if (!(getField('first_name').value || '').trim()) {
          setFieldError('first_name', 'Please complete this required field.');
          valid = false;
        }
        if (!(getField('last_name').value || '').trim()) {
          setFieldError('last_name', 'Please complete this required field.');
          valid = false;
        }
        var email = (getField('email').value || '').trim();
        if (!email) {
          setFieldError('email', 'Please complete this required field.');
          valid = false;
        } else if (!isValidEmail(email)) {
          setFieldError('email', 'Please enter a valid email address.');
          valid = false;
        }
        var phone = (getField('phone').value || '').trim();
        if (!phone) {
          setFieldError('phone', 'Please complete this required field.');
          valid = false;
        } else if (!isValidPhone(phone)) {
          setFieldError('phone', 'Please enter a valid phone number.');
          valid = false;
        }
        if (!getField('consultation_type').value) {
          setFieldError('consultation_type', 'Please complete this required field.');
          valid = false;
        }
        var preferredDate = getField('preferred_date').value;
        if (!preferredDate) {
          setFieldError('preferred_date', 'Please complete this required field.');
          valid = false;
        } else if (isPastDate(preferredDate)) {
          setFieldError('preferred_date', 'Please choose a future date.');
          valid = false;
        } else if (isSunday(preferredDate)) {
          setFieldError('preferred_date', 'Sundays are unavailable. Please choose another day.');
          valid = false;
        }
        if (!getField('preferred_time').value) {
          setFieldError('preferred_time', 'Please complete this required field.');
          valid = false;
        }
        if (!getField('help_with').value) {
          setFieldError('help_with', 'Please complete this required field.');
          valid = false;
        }
        return valid;
      }
  
      if (dateInput) {
        dateInput.addEventListener('change', function () {
          if (isSunday(dateInput.value)) {
            setFieldError('preferred_date', 'Sundays are unavailable. Please choose another day.');
          } else if (isPastDate(dateInput.value)) {
            setFieldError('preferred_date', 'Please choose a future date.');
          } else {
            setFieldError('preferred_date', '');
          }
        });
      }
  
      form.querySelectorAll('[data-field]').forEach(function (field) {
        ['input', 'change'].forEach(function (evt) {
          field.addEventListener(evt, function () {
            var name = field.getAttribute('data-field');
            if (name) setFieldError(name, '');
          });
        });
      });
  
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!validateForm()) {
          var firstInvalid = form.querySelector('.primo-consult-form__field.is-invalid [data-field]');
          if (firstInvalid) firstInvalid.focus();
          return;
        }
        if (!webhookUrl) {
          if (formError) formError.hidden = false;
          return;
        }
  
        var budgetField = getField('budget');
        var messageField = getField('message');
  
        var payload = {
          first_name: getField('first_name').value.trim(),
          last_name: getField('last_name').value.trim(),
          email: getField('email').value.trim(),
          phone: getField('phone').value.trim(),
          consultation_type: getField('consultation_type').value,
          preferred_date: getField('preferred_date').value,
          preferred_time: getField('preferred_time').value,
          help_with: getField('help_with').value,
          budget: budgetField ? budgetField.value : '',
          message: messageField ? messageField.value.trim() : ''
        };
  
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting...';
        }
        if (formError) formError.hidden = true;
  
        fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            handleFormSuccess(form, {
              formBody: formBody,
              successPanel: successPanel
            });
          })
          .catch(function () {
            if (formError) formError.hidden = false;
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitText;
            }
          });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initConsultationForms);
    } else {
      initConsultationForms();
    }
  
    document.addEventListener('shopify:section:load', initConsultationForms);
  })();